import { ServiceType, ServiceTypes } from '@patient-ui/shared/models';

export function getServiceTypesArray(
  serviceTypes: ServiceTypes
): ServiceType[] {
  return Object.values(serviceTypes);
}
